import React, {useState} from "react";
import BootstrapTable from "react-bootstrap/Table";
import RepeaterIcon from "../../data/icons/중계기/_THM_Mint.png";
import {Button} from "react-bootstrap";
import Swal from "sweetalert2";
import {postRptDeviceDelete} from "../../api/apiClient";
import ModalCtrl from "../../pages/subPages/ModalCtrl";

const MarkerRepListTable = ({
                              propMarkerList,
                              setMarkerList,
                              propSetupFilter,
                              showPopup = null,
                              propAuth
                            }) => {
  const onClick = (e) => {
    const id = e.target.id;
    console.log(id)
    setMarkerList(
        propMarkerList.map((elem) => {
          return {
            ...elem,
            status: (elem.id === id) ? 'Mint' : 'Normal',
            selected: (elem.id === id) ? true : false
          }
        })
    )
  }

  const sourceDragEndHandler = (e) => {
    // console.log(e);
    // console.log(e.target.id);
    const id = e.target.id;
    setMarkerList(
        propMarkerList.map((elem) => {
          if (elem.id === id) {
            return {
              ...elem,
              x: 0,
              y: 0,
              setup_yn: 'Y',
              selected: true,
              status: 'Mint',
              isModified: true,
            }
          } else {
            return {
              ...elem,
              selected: false,
              status: 'Normal'
            }
          }
        })
    )
  };

  const onDelete = (id, rpeatId) => {
    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `중계기(${rpeatId})를 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        postRptDeviceDelete(id)
            .then(res => {
              if (res.data.status === 200) {
                Swal.fire(
                    '삭제되었습니다!',
                    '',
                    'success'
                );
              }
              // hClose(true);
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      }
    })
  };

  // control ////////////////////////////////////
  const [stCtlShow, setCtlShow] = useState(false);
  const [stRpt, setStRpt] = useState({rpeat_id: '0'});

  const onControl = () => {
    if (stRpt.rpeat_id === "") {
      Swal.fire("장비 등록을 먼저 하세요.");
      return;
    }
    setCtlShow(true);
  }


  return (
      <>
        <ModalCtrl
            propShow={stCtlShow}
            propDevice={stCtlShow.rpeat_id}
            propType={'2'}
            setShow={setCtlShow}
        />
        <BootstrapTable hover className={"table repeater-table text-center"}>
          <thead className={"table-head text-secondary"}>
          <tr className={""}>
            <th className={"d-none"}>rpeat_no</th>
            <th className={"col"}></th>
            <th className={"col"}>장비ID</th>
            <th className={"col"}>시설명</th>
            <th className={"col"}>층</th>
            <th className={"col"}>실명</th>
            <th className={"col"}>모델</th>
            <th className={"col"}>FW버전</th>
            <th className={"col"}>동기상태</th>
            <th className={"col"}></th>
          </tr>
          </thead>
          <tbody className={"table-body text-white"}>
          {
            Array.isArray(propMarkerList) ?
                (propMarkerList.map((elem, idx) => {
                  if (elem.setup_yn === propSetupFilter) {
                    return <tr key={idx} className={elem.selected == true ? 'table-secondary' : ''}>
                      <td className={"d-none"}>{elem.rpeat_no}</td>
                      <td>
                        {propSetupFilter === 'N' ?
                            <img
                                src={RepeaterIcon}
                                alt={'RepeaterIcon'}
                                className={"icon align-middle me-1"}
                                id={elem.id}
                                onDragEnd={sourceDragEndHandler}
                                draggable
                            /> :
                            <img
                                src={RepeaterIcon}
                                alt={'RepeaterIcon'}
                                className={"icon align-middle me-1"}
                                id={elem.id}
                                onClick={onClick}
                            />
                        }
                      </td>
                      <td className={`${propAuth === "2" ? "column-title" : ''}`}
                          onClick={(e) => {
                            if (propAuth === "2") {
                              showPopup(e, elem.id);
                            }
                          }}
                      >{elem.rpeat_id}</td>
                      <td>{elem.fclty_nm}</td>
                      <td>{elem.fclty_dtl_nm}</td>
                      <td>{elem.rpeat_lc_nm}</td>
                      <td>{elem.modl}</td>
                      <td>{elem.fw_ver}</td>
                      <td>{elem.sync_yn_nm}</td>
                      {/*<td>*/}
                      {/*  <Button type={"button"} variant="primary"*/}
                      {/*      // onClick={handleOpenLayer}*/}
                      {/*          data-id={elem.gtwy_no}*/}
                      {/*          onClick={(e) => {*/}
                      {/*            showPopup(e, elem.id);*/}
                      {/*          }}*/}
                      {/*  >*/}
                      {/*    수정*/}
                      {/*  </Button>*/}
                      {/*  <span> </span>*/}
                      {/*  <Button type={"button"} variant="danger"*/}
                      {/*          data-fcltyno={elem.fclty_no}*/}
                      {/*          data-name={elem.fclty_nm}*/}
                      {/*          data-gtwyno={elem.gtwy_no}*/}
                      {/*      // onClick={delItem}*/}
                      {/*          onClick={(e) => {*/}
                      {/*            onDelete(elem.id, elem.rpeat_id);*/}
                      {/*          }}*/}
                      {/*  >*/}
                      {/*    삭제*/}
                      {/*  </Button>*/}
                      {/*  <span> </span>*/}
                      {/*  <Button type={"button"} variant={"success"}*/}
                      {/*      // onClick={ctlItem}*/}
                      {/*          data-fcltyno={elem.fclty_no}*/}
                      {/*          data-name={elem.fclty_nm}*/}
                      {/*          data-gtwyno={elem.gtwy_no}*/}
                      {/*          onClick={(e) => {*/}
                      {/*            setStRpt({rpeat_id: elem.rpeat_id});*/}
                      {/*            onControl();*/}
                      {/*          }}*/}
                      {/*  >*/}
                      {/*    제어*/}
                      {/*  </Button>*/}
                      {/*</td>*/}
                    </tr>;
                  }
                })) :
                ('')
          }
          </tbody>
        </BootstrapTable>
      </>
  );
}

export default MarkerRepListTable;